import gql from 'graphql-tag';

export const AccountNotificationFragment = gql`
  fragment AccountNotificationFragment on account_GlobalSet {
    heading
    onOffSwitch
    description
  }
`;
